import {
  Configuration,
  DefaultApi as RegionsConfigAPI,
  PhrasesApi as PhrasesAPI,
  LoadSpecificationDataApi as MaterialToSAPSpecificationDataApi,
} from '@coac-gmbh/saifty-phrases'
import {
  DataFlowManagementApi,
  DataAssetManagementApi,
  FavoriteAPIsApi,
  MetricsApi,
  TemplateManagementApi,
  SupplierRequestManagementApi,
  AccountManagementApi,
  AccountRoleManagementApi,
  PhraseRequestAPIsApi,
  InstanceShareManagementApi,
  InstanceConfigurationApi,
  ApprovalApi as DataObjectApprovalApi,
} from '@coac-gmbh/saifty-main-apis'
import { LibraryAPIsApi } from '@coac-gmbh/library-api'
import { FileStorageApi } from '@coac-gmbh/file-storage-api'
import {
  GenericExtractionApi,
  DataFlowManagementApi as RobotsDataFlowApi,
  TemplateManagementApi as WorkflowTemplateManagementApi,
} from '@coac-gmbh/saifty-robots-api'
import {
  DataobjectManagementApi as ComponentManagementApi,
  PassportManagementApi as QueryManagementApi,
  QueryGeneratorApi,
  FlowManagementApi as QueryFlowManagementApi,
} from '@coac-gmbh/saifty-query-builder'
import {
  SpecificationAPIApi as SAPSpecificationApi,
  ConfigLoadManagementAPIApi as SAPConfigLoadManagementApi,
  SpecificationFilesAPIApi as SAPSpecificationFilesApi,
  // SyncSpecificationFileAPIApi as SAPSyncSpecificationFileApi,
} from '@coac-gmbh/saifty-sap'
import { SyncConfigurationsAPIApi as SAPSyncSpecificationFileApi } from '@coac-gmbh/sap-sync-configuration-api'
import { DefaultApi } from '@coac-gmbh/saifty-gpt-api'
import { NotificationAPIsApi as NotificationsApi } from '@coac-gmbh/notification-api'
import { DefaultApi as aiChatApi } from '@coac-gmbh/saifty-ai-chat-api'
import {
  DefaultApi as DataSpaceApi,
  DiscoveryApi,
  MappingAPIApi,
  ExtractionAPIApi as ExtractionAPI,
  SHARINGAPIApi as DataSpaceSharingApi,
} from '@coac-gmbh/saifty-orchestrator-api'
import { OrganizationManagementApi, CertificateManagementApi } from '@coac-gmbh/saifty-organization-api'
import { CertificateManagementApi as CCMCertificateManagementApi } from '@coac-gmbh/saifty-ccm-api'
import axiosInstance from './axios'

const SAP_GATEWAYS_PER_BUSINESS_UNITS =
  window.ENV.API_SAP_GATEWAYS_PER_BUSINESS_UNITS || import.meta.env.VITE_API_SAP_GATEWAYS_PER_BUSINESS_UNITS

const API_SAIFTY_SAP_BASE_URL = window.ENV.API_SAP_BASE_URL || import.meta.env.VITE_API_SAIFTY_SAP_BASE_URL

export const SAIFTY_APIS_BASE_URL = window.ENV.API_MONOLITH_BASE_URL || import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL

const configPhrases = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_PHRASES_BASE_URL || window.ENV.API_PHRASES_BASE_URL,
})
const configSaiftyApis = new Configuration({
  basePath: SAIFTY_APIS_BASE_URL,
})
const configFileSystemApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_FILE_SYSTEM_BASE_URL || window.ENV.API_FILE_SYSTEM_BASE_URL,
})
const configLibraryApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_LIBRARY_APIS_BASE_URL || window.ENV.API_LIBRARY_APIS_BASE_URL,
})
const configQueryBuilderApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_QUERY_BUILDER_BASE_URL || window.ENV.API_QUERY_BUILDER_BASE_URL,
})

const configSaiftySAPApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_SAP_BASE_URL || window.ENV.API_SAP_BASE_URL,
})

const configSaiftySyncSpecificationApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAP_SYNC_CONFIG_BASE_URL || window.ENV.API_SAP_SYNC_CONFIG_BASE_URL,
})

const configSaiftyGPTApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_GPT_BASE_URL || window.ENV.API_SAIFTY_GPT_BASE_URL,
})

const configNotificationsApis = new Configuration({
  basePath: `https://${import.meta.env.VITE_NOTIFICATIONS_WS_HOST || window.ENV.NOTIFICATIONS_WS_HOST}`,
})

const aiChatApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_AI_CHAT_BASE_URL || window.ENV.API_SAIFTY_AI_CHAT_BASE_URL,
})

const dataSpaceApis = new Configuration({
  basePath: import.meta.env.VITE_SAIFTY_DATA_SPACE_BASE_URL || window.ENV.API_SAIFTY_DATA_SPACE_BASE_URL,
})

const configRobotsApis = new Configuration({
  basePath: import.meta.env.VITE_API_SAIFTY_ROBOTS_BASE_URL || window.ENV.API_SAIFTY_ROBOTS_BASE_URL,
})

const organizationManagementApis = new Configuration({
  basePath: import.meta.env.VITE_SAIFTY_DATA_SPACE_BASE_URL || window.ENV.API_SAIFTY_DATA_SPACE_BASE_URL,
})

const certificateManagementApis = new Configuration({
  basePath: import.meta.env.VITE_SAIFTY_DATA_SPACE_BASE_URL || window.ENV.API_SAIFTY_DATA_SPACE_BASE_URL,
})

const ccmCertificateManagementApis = new Configuration({
  basePath: import.meta.env.VITE_SAIFTY_DATA_SPACE_BASE_URL || window.ENV.API_SAIFTY_DATA_SPACE_BASE_URL,
})

// Saifty AI Chat
export const AIChatApi = new aiChatApi(aiChatApis, undefined, axiosInstance)

// Saifty Notifications
export const notificationsApi = new NotificationsApi(configNotificationsApis, undefined, axiosInstance)

// SAIFTY Phrases
export const phrasesApi = new PhrasesAPI(configPhrases, undefined, axiosInstance)

export const phrasesRequestApi = new PhraseRequestAPIsApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY region phrases
export const regionsConfigApi = new RegionsConfigAPI(configPhrases, undefined, axiosInstance)

export const materialToSAPSpecificationDataApi = new MaterialToSAPSpecificationDataApi(
  configPhrases,
  undefined,
  axiosInstance,
)

// SAIFTY Flows
export const dataFlowApi = new DataFlowManagementApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Favorites
export const favoritesApi = new FavoriteAPIsApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Data assets
export const dataAssetsApi = new DataAssetManagementApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Data assets
export const approvalsApi = new DataObjectApprovalApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Metrics
export const metricsApi = new MetricsApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Templates for Passports
export const templateManagementApi = new TemplateManagementApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Request management for Passports
export const supplierRequestManagementApi = new SupplierRequestManagementApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Component management for query builder
export const componentManagementApi = new ComponentManagementApi(configQueryBuilderApis, undefined, axiosInstance)

// SAIFTY Query management for query builder
export const queryManagementApi = new QueryManagementApi(configQueryBuilderApis, undefined, axiosInstance)

// SAIFTY Query builder - generator
export const queryGeneratorApi = new QueryGeneratorApi(configQueryBuilderApis, undefined, axiosInstance)

// SAIFTY Query flow management for query builder
export const queryFlowManagementApi = new QueryFlowManagementApi(configQueryBuilderApis, undefined, axiosInstance)

// SAIFTY Account Management
export const accountManagementApi = new AccountManagementApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Role Management
export const roleManagementApi = new AccountRoleManagementApi(configSaiftyApis, undefined, axiosInstance)

// SAIFTY Library
export const libraryApi = new LibraryAPIsApi(configLibraryApis, undefined, axiosInstance)

// SAIFTY File Storage
export const fileStorageApi = new FileStorageApi(configFileSystemApis, undefined, axiosInstance)

// SAIFTY Data Space - Sub models
export const dataSpaceSubModelsApi = new DataSpaceApi(dataSpaceApis, undefined, axiosInstance)

// SAIFTY Data Space - Discovery
export const dataSpaceDiscoveryApi = new DiscoveryApi(dataSpaceApis, undefined, axiosInstance)

// SAIFTY Data Space - Mapping
export const dataSpaceMappingApi = new MappingAPIApi(dataSpaceApis, undefined, axiosInstance)

// SAIFTY Robots
export const genericExtractionApi = new GenericExtractionApi(configRobotsApis, undefined, axiosInstance)

export const robotsDataFlowApi = new RobotsDataFlowApi(configRobotsApis, undefined, axiosInstance)

export const workflowTemplateManagementApi = new WorkflowTemplateManagementApi(
  configRobotsApis,
  undefined,
  axiosInstance,
)

// SAIFTY Data Space - Sharing
export const dataSpaceSharingApi = new DataSpaceSharingApi(dataSpaceApis, undefined, axiosInstance)

// SAIFTY Data Space - Extraction
export const dataSpaceExtractionApi = new ExtractionAPI(dataSpaceApis, undefined, axiosInstance)

// SAIFTY Organization management
export const organizationManagementApi = new OrganizationManagementApi(
  organizationManagementApis,
  undefined,
  axiosInstance,
)

// SAIFTY Certificate Management
export const certificateManagementApi = new CertificateManagementApi(
  certificateManagementApis,
  undefined,
  axiosInstance,
)

export const ccmCertificateManagementApi = new CCMCertificateManagementApi(
  ccmCertificateManagementApis,
  undefined,
  axiosInstance,
)

// SAIFTY SAP
export const sapSpecificationApi = new SAPSpecificationApi(configSaiftySAPApis, undefined, axiosInstance)
export const sapSpecificationFilesApi = new SAPSpecificationFilesApi(configSaiftySAPApis, undefined, axiosInstance)
export const sapSyncSpecificationFileApi = new SAPSyncSpecificationFileApi(
  configSaiftySyncSpecificationApis,
  undefined,
  axiosInstance,
)

function getSAPApiBaseUrl(
  envGateways: string | undefined,
  businessUnit: string,
  envBaseUrl?: string | undefined,
): string {
  let apiURL = envBaseUrl || ''

  const sapGateways = envGateways || ''
  if (businessUnit && sapGateways) {
    sapGateways.split(',').forEach((item) => {
      const [, unit, url] = item.match(/([^:]*):(.*)/) ?? []
      if (unit.toLowerCase() === businessUnit.toLowerCase() && url) {
        apiURL = url
      }
    })
  }

  return apiURL
}

export function getSAPSpecificationApiForBusinessUNIT(businessUnit: string) {
  const apiURL = getSAPApiBaseUrl(SAP_GATEWAYS_PER_BUSINESS_UNITS, businessUnit, API_SAIFTY_SAP_BASE_URL)

  const configApi = new Configuration({ basePath: apiURL })
  return new SAPSpecificationApi(configApi, undefined, axiosInstance)
}

export function getSAPconfigLoadManagementForBusinessUNIT(businessUnit: string) {
  const apiURL = getSAPApiBaseUrl(SAP_GATEWAYS_PER_BUSINESS_UNITS, businessUnit)
  if (!apiURL) return

  const configApi = new Configuration({ basePath: apiURL })
  return new SAPConfigLoadManagementApi(configApi, undefined, axiosInstance)
}

export function getSAPSpecificationFilesApiByBusinessUNIT(businessUnit: string) {
  const apiURL = getSAPApiBaseUrl(SAP_GATEWAYS_PER_BUSINESS_UNITS, businessUnit, API_SAIFTY_SAP_BASE_URL)

  const configApi = new Configuration({ basePath: apiURL })
  return new SAPSpecificationFilesApi(configApi, undefined, axiosInstance)
}

// SAIFTY GPT
export const gptApi = new DefaultApi(configSaiftyGPTApis, undefined, axiosInstance)

export const organizationsApi = new InstanceShareManagementApi(configSaiftyApis, undefined, axiosInstance)

export const organizationsConfigApi = new InstanceConfigurationApi(configSaiftyApis, undefined, axiosInstance)

export function getMonolithAPIsByBaseURL(apiURL: string) {
  const cleanUrl = apiURL.replace(/\/$/, '')
  const configApi = new Configuration({ basePath: cleanUrl })
  return new DataAssetManagementApi(configApi, undefined, axiosInstance)
}
